import React from 'react';

import americanExpressImg from '../../assets/img/cards/american-express.png';
import dinersClubImg from '../../assets/img/cards/diners-club.png';
import discoverImg from '../../assets/img/cards/discover.png';
import jcbImg from '../../assets/img/cards/jcb.png';
import mastercardImg from '../../assets/img/cards/mastercard.png';
import unionPayImg from '../../assets/img/cards/union-pay.png';
import visaImg from '../../assets/img/cards/visa.png';

function CardDetails({ userSubscription, user }) {
  const getPaymentMethodImage = (card) => {
    let image = null;
    switch (card.brand) {
      case 'Visa':
        image = visaImg;
        break;
      case 'American Express':
        image = americanExpressImg;
        break;
      case 'Diners Club':
        image = dinersClubImg;
        break;
      case 'Discover':
        image = discoverImg;
        break;
      case 'JCB':
        image = jcbImg;
        break;
      case 'MasterCard':
        image = mastercardImg;
        break;
      case 'UnionPay':
        image = unionPayImg;
        break;
      default:
        image = null;
        break;
    }

    if (card && card.brand && image) {
      return (
        <img className="cardImage" src={image} alt="" height="45" width="78" />
      );
    }
  };

  const getBrandAndLastFour = (card) => {
    if (card) {
      return `${card.brand} ****${card.last4}`;
    }
    return '';
  };

  const getCardExpirationDate = (card) => {
    if (card) {
      return `Expires: ${card.exp_month}/${card.exp_year}`;
    }
    return '';
  };

  return (
    <>
      {userSubscription &&
      userSubscription.card &&
      userSubscription.card.brand ? (
        <div className="card-details-container">
          <div className="card-logo">
            {getPaymentMethodImage(userSubscription.card)}
          </div>
          <div className="card-data">
            <div className="last-four">
              {getBrandAndLastFour(userSubscription.card)}
            </div>
            <div className="expiration-date">
              {getCardExpirationDate(userSubscription.card)}
            </div>
          </div>
        </div>
      ) : (
        <>
          {user && user.isFreeAccount ? (
            <div className="no-details-container">
              No card data available. Upgrade your account to have full access
              to all study material and features
            </div>
          ) : (
            <div className="no-details-container">No card data available</div>
          )}
        </>
      )}
    </>
  );
}

export default CardDetails;
